import React, { useState, useEffect, useCallback } from "react";
import {
  Container, Paper, Typography, Button, TextField, Table, TableBody, TableCell,
  TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogContent,
  DialogActions, Chip, makeStyles
} from "@material-ui/core";
import { Add, Edit, Delete } from "@material-ui/icons";
import { getWhatsappTemplates, createWhatsappTemplate, updateWhatsappTemplate, deleteWhatsappTemplate } from "../../services/api.new-features";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2) },
  paper: { padding: theme.spacing(2), marginTop: theme.spacing(2) },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center" },
}));

const statusColors = { pending: "#ff9800", approved: "#4caf50", rejected: "#f44336" };

const WhatsappTemplates = () => {
  const classes = useStyles();
  const [templates, setTemplates] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [current, setCurrent] = useState({});

  const load = useCallback(async () => {
    try {
      const res = await getWhatsappTemplates({});
      setTemplates(res.data.templates || res.data);
    } catch (e) { toast.error("Erro ao carregar templates"); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSave = async () => {
    try {
      if (current.id) { await updateWhatsappTemplate(current.id, current); }
      else { await createWhatsappTemplate(current); }
      setDialog(false); setCurrent({}); load();
      toast.success("Template salvo!");
    } catch (e) { toast.error("Erro ao salvar"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Excluir template?")) return;
    try { await deleteWhatsappTemplate(id); load(); } catch (e) { toast.error("Erro"); }
  };

  return (
    <Container maxWidth="lg" className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h5">Templates WhatsApp</Typography>
        <Button variant="contained" color="primary" startIcon={<Add />}
          onClick={() => { setCurrent({ language: "pt_BR", status: "pending" }); setDialog(true); }}>
          Novo Template</Button>
      </div>

      <Paper className={classes.paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Categoria</TableCell>
              <TableCell>Idioma</TableCell>
              <TableCell>Corpo</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templates.map(t => (
              <TableRow key={t.id}>
                <TableCell>{t.name}</TableCell>
                <TableCell>{t.category}</TableCell>
                <TableCell>{t.language}</TableCell>
                <TableCell style={{ maxWidth: 300, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {t.body}</TableCell>
                <TableCell>
                  <Chip size="small" label={t.status}
                    style={{ backgroundColor: statusColors[t.status] || "#9e9e9e", color: "#fff" }} />
                </TableCell>
                <TableCell>
                  <IconButton size="small" onClick={() => { setCurrent(t); setDialog(true); }}><Edit /></IconButton>
                  <IconButton size="small" onClick={() => handleDelete(t.id)}><Delete /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Dialog open={dialog} onClose={() => setDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>{current.id ? "Editar Template" : "Novo Template"}</DialogTitle>
        <DialogContent>
          <TextField fullWidth margin="dense" label="Nome" value={current.name || ""}
            onChange={e => setCurrent({ ...current, name: e.target.value })} />
          <TextField fullWidth margin="dense" label="Categoria" value={current.category || ""}
            onChange={e => setCurrent({ ...current, category: e.target.value })} />
          <TextField fullWidth margin="dense" label="Idioma" value={current.language || "pt_BR"}
            onChange={e => setCurrent({ ...current, language: e.target.value })} />
          <TextField fullWidth margin="dense" label="Cabeçalho" value={current.headerContent || ""}
            onChange={e => setCurrent({ ...current, headerContent: e.target.value })} />
          <TextField fullWidth margin="dense" label="Corpo da Mensagem" multiline rows={5}
            value={current.body || ""} onChange={e => setCurrent({ ...current, body: e.target.value })}
            helperText="Use {{1}}, {{2}}, etc. para variáveis" />
          <TextField fullWidth margin="dense" label="Rodapé" value={current.footer || ""}
            onChange={e => setCurrent({ ...current, footer: e.target.value })} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog(false)}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained" color="primary">Salvar</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default WhatsappTemplates;